import * as actions from '../actions'

const defaultState = null

export default function emailTemplate(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_EMAIL_TEMPLATE:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.CLEAN_EMAIL_TEMPLATES:
            return defaultState

        default:
            return state
    }
}
